__turbopack_context__.v({
  "messagesList": "message-list-module-scss-module__HBa1ga__messagesList",
  "messagesList__show_more": "message-list-module-scss-module__HBa1ga__messagesList__show_more",
  "streamStatus": "message-list-module-scss-module__HBa1ga__streamStatus",
  "streamStatusBreathe": "message-list-module-scss-module__HBa1ga__streamStatusBreathe",
  "streamStatusShimmer": "message-list-module-scss-module__HBa1ga__streamStatusShimmer",
  "streamStatus__text": "message-list-module-scss-module__HBa1ga__streamStatus__text",
});
